import api from "../api"
export default {
	/**
	 * 
	 * @param {number} template 
	 * @param {number} recipient 
	 * @param {string} invitationcode 
	 * @param {expirydate} expirydate 
	 */
	async addRequest(template, recipients, invitationcodes, expirydate,flowDownAuditId, auditor, fromDate, toDate, hint, visitDays, recipientUsername) {
		let value = await api.post(`/audit-requests/`, {
			template: template,
			recipients: recipients.join(","),
			invitationcodes: invitationcodes.join(","),
			expirydate: expirydate,
			flowDownAuditId:flowDownAuditId,
			auditor: auditor,
			fromDate: fromDate, 
			toDate: toDate,
			hint: hint,
			visitDays: visitDays,
			recipientUsername: recipientUsername
		})	
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
	 * 
	 * @param {boolean} edit 
	 * @param {number} auditID 
	 * @param {string} comment 
	 * @param {expirydate} expirydate 
	 */
	async addRequestEdit(edit, auditID, comment, expirydate) {
		let value = await api.post(`/audit-requests/`, {
			edit: edit,
			auditID: auditID,
			comment: comment,
			expirydate: expirydate
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
	 * Returns boolean for success
	 * @param {number} id 
	 * @param {Object[]} answers 
	 */
	async updateRequest(id, answers) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/audit-requests/${id}`, { name: name, answers: answers })
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return !!value.data.data[0]

	},

	/**
	 * Delete request
	 * @param {number} id ID of request
	 */
	async deleteRequest(id) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		let value = await api.delete(`/audit-requests/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	/**
	 * Gets a list of templates
	 * @param {string} type 'incoming' | 'outgoing'
	 */
	async list({ type, offset, limit, edit, startDate, endDate, flowDown,
		otherParams }) {
		let value = await api.get(`/audit-requests/`, {
			params: {
				type: type,
				offset: isNaN(offset) ? 0 : offset,
				limit: isNaN(limit) ? undefined : limit,
				edit: edit,
				startDate: startDate,
				endDate: endDate,
				flowDown: flowDown,
				...otherParams
			}
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return { items: data, total: value.data.metadata.pagination.totalRecords }
	},
	async get(id) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		let value = await api.get(`/audit-requests/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		
		return data
	},

	async submitFeedback(id, submitTime, platform, navigation, task, comment, module) {
		/* if (isNaN(parseInt(id))) {
			throw new Error("Feedback should give a number")
		} */
		let value = await api.post(`/audit-requests/feedback/`, {
			id: id,
			submitTime: submitTime,
			platform: platform,
			navigation: navigation, 
			task: task,
			comment: comment,
			module: module
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			console.log(error)
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async getFeedback() {
		let value = await api.get(`/audit-requests/feedback/`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	/**
	 * Gets a list of templates
	 * @param {string} type 'incoming' | 'outgoing'
	 */
	async onsiteList({ type, offset, limit, edit, startDate, endDate,
		otherParams }) {
		let value = await api.get(`/onsite-audit-requests/`, {
			params: {
				type: type,
				offset: isNaN(offset) ? 0 : offset,
				limit: isNaN(limit) ? undefined : limit,
				edit: edit,
				startDate: startDate,
				endDate: endDate,
				...otherParams
			}
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return { items: data, total: value.data.metadata.pagination.totalRecords }
	},
	async pendingAuditorlist() {
		let value = await api.get(`/onsite-auditor-pending-requests/`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		
		return { items: data, total: value.data.metadata.pagination.totalRecords }
	},
	async getGuestRequest() {
		let value = await api.get("/guest-requests")
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return {
			items: value.data.data,
			total: value.data.metadata.pagination.totalRecords
		}
	},
	async updateGuest() {
		let value = await api.put(`/guest-requests`)
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return !!value.data.data[0]
	},
}